import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import CustomPaginationActionsTable from './AMinboxTable'
import AMinboxForm from './AMinboxForm';
import OffAssetHandoverForm from './OffAssetHandoverForm'
import StotoStoAssetTransform from './StotoStoAssetTransform'

const Container = styled.div``
const Wrapper = styled.div``


const AMinbox = () => {
  const [reqid, setId] = useState('')
  const [changepage, setChangepage] = useState([true, false, false, false])

  const handleEditclick = (e, reqid, reqtype) => {

    setId(reqid)

    if (reqtype === 'issue') {
      setChangepage([false, true, false, false])
    } else if (reqtype === 'ofc_asset_handover') {
      setChangepage([false, false, true, false])
    } else if (reqtype === 'str_to_str') {
      setChangepage([false, false, false, true])
    }
  }

  return (
    <Container>
      <Wrapper>
        {changepage[0] && <CustomPaginationActionsTable handleEditclick={handleEditclick} />}
        {changepage[1] && <AMinboxForm reqid={reqid} setChangepage={setChangepage} />}
        {changepage[2] && <OffAssetHandoverForm reqid={reqid} setChangepage={setChangepage} />}
        {changepage[3] && <StotoStoAssetTransform reqid={reqid} setChangepage={setChangepage} />}
      </Wrapper>
    </Container>
  )
}

export default AMinbox